module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-brands-400.woff?fb598c9ccecd5fa1c6c769d0be60973b";